import lk from '@/api/lk'
import router from "@/router/index";
// this page used by lk

const user = {
    state: {
        c_id: null,
        c_name: null,
        c_avatar: null,
        c_role_id: null,
        c_role_name: null,
        c_role_level: null,
        c_project_id: null,
        c_menu: null,
        c_bread: null,
        c_index: null,
        activeMenu: null
    },

    mutations: {
        SET_C_ID: (state, value) => {
            state.c_id = value
        },
        SET_C_NAME: (state, value) => {
            state.c_name = value
        },
        SET_C_AVATAR: (state, value) => {
            state.c_avatar = value
        },
        SET_C_ROLE_ID: (state, value) => {
            state.c_role_id = value
        },
        SET_C_ROLE_NAME: (state, value) => {
            state.c_role_name = value
        },
        SET_C_ROLE_LEVEL: (state, value) => {
            state.c_role_level = value
        },
        SET_C_PROJECT_ID: (state, value) => {
            state.c_project_id = value
        },
        SET_C_MENU: (state, value) => {
            state.c_menu = value
        },
        SET_C_BREAD: (state, value) => {
            state.c_bread = value
        },
        SET_C_INDEX: (state, value) => {
            state.c_index = value
        },
        SET_ACTIVEMENU: (state, value) => {
            state.activeMenu = value
        },
    },

    actions: {
        GetInfo({ commit }) {
            lk.getUserInfoByMobile({ username: sessionStorage.getItem('username') }).then((response) => {
                let result = response.data
                commit('SET_C_ID', result['c_id'])
                commit('SET_C_NAME', result['c_name'])
                commit('SET_C_AVATAR', result['c_avatar'])
                commit('SET_C_ROLE_ID', result['c_role_id'])
                commit('SET_C_ROLE_NAME', result['c_role_name'])
                commit('SET_C_ROLE_LEVEL', result['c_role_level'])
                commit('SET_C_PROJECT_ID', result['c_projectId'])
            })

        },
        // 生成路由
        GetMenu({ commit }) {
            if (user.state.c_menu == null) {
                lk.getMenu({ username: sessionStorage.getItem('username'), projectId: JSON.parse(sessionStorage.getItem("project")).c_id }).then(r => {
                    let data = r.data;
                    let flag = false;
                    const allRouters = []
                    data.forEach(item => {
                        const oRouter = {
                            id: item.c_id,
                            name: item.c_name,
                            path: item.c_path,
                            component(resolve) {
                                require([`../../views/${item.c_component}.vue`], resolve);
                            },
                            meta: {
                                index: item.c_index,
                                title: item.c_name,
                                keepAlive: item.c_keepAlive == 1 ? true : false,
                                show: item.c_show == 1 ? true : false,
                                id: item.c_id,
                                parentId: item.c_parentId,
                                icon: item.c_icon,
                                hasChildren: item.hasChildren,
                                level: item.c_level,
                                children: null
                            }
                        };
                        allRouters.push(oRouter)
                        commit('SET_C_MENU', allRouters)
                        if(item.c_component != null && flag == false){
                            commit('SET_C_INDEX', item.c_path)
                            flag = true;
                        }
                    });
                    allRouters.push(
                        {
                            path: "/404",
                            name: "notFound",
                            component(resolve) {
                                require([`../../views/error/Error404.vue`], resolve);
                            },
                            meta: {
                                title: '404',
                                keepAlive: false,
                                show: false,
                                id: 404,
                                parentId: 0,
                                icon: ''
                            }
                        },
                        {
                            path: "*",
                            redirect: "/404",
                            meta: {
                                show: false
                            }
                        }
                    )
                    router.addRoutes(allRouters)


                });
            }
        },
    }
}

export default user


// WEBPACK FOOTER //
// ./src/store/modules/user.js